import Vue from 'vue';

export default {
    // Busca todas as solicitacoes
    listarTodos() {
        return Vue.prototype.$http.get('/solicitacao');
    },

    // Busca detalhes de uma solicitacao com seus checklists vinculados
    buscarPorId(id) {
        return Vue.prototype.$http.get(`/solicitacao/${id}`);
    },

    // Cria uma nova solicitacao
    criar(payload) {
        return Vue.prototype.$http.post('/solicitacao', payload);
    },

    // Autoriza ou recusa todos os checklists de uma solicitacao
    autorizar(id, autorizado) {
        return Vue.prototype.$http.put(`/solicitacao/${id}/autorizar`, { autorizado });
    },

    // Cancela uma solicitacao e todos os seus checklists pendentes
    cancelar(id) {
        return Vue.prototype.$http.put(`/solicitacao/${id}/cancelar`);
    },

    // Finaliza uma solicitacao (requer todos os checklists finalizados)
    finalizar(id) {
        return Vue.prototype.$http.put(`/solicitacao/${id}/finalizar`);
    },

    // Adiciona checklists e atualiza a descrição de uma solicitação existente
    adicionarChecklists(id, payload) {
        return Vue.prototype.$http.put(`/solicitacao/${id}/checklists`, payload);
    }
};